import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-qr_add",
  "use": "icon-qr_add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-qr_add\"><path d=\"M512 890.688a48 48 0 0 1-48-48V181.312a48 48 0 0 1 96 0v661.376a48 48 0 0 1-48 48z\" fill=\"#1296db\" p-id=\"1634\" /><path d=\"M842.688 560H181.312a48 48 0 0 1 0-96h661.376a48 48 0 0 1 0 96z\" fill=\"#1296db\" p-id=\"1635\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol